// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__V2rIE"};